<template>
  <span class="badge" :class="['badge--theme-' + theme, 'badge--align-' + iconPlacement, `badge--type-${type}`]">
    <span class="badge__dot" v-if="type === 'dot'"></span>

    <span>
      <slot>{{ value }}</slot>
    </span>
    <slot name="icon"><FontAwesomeIcon v-if="iconComp" v-bind="iconComp" class="badge__icon" /></slot>
  </span>
</template>

<script>
import { IconBinding } from '@/utils'

export default {
  props: {
    theme: {
      type: String,
      default: 'default',
    },
    type: {
      type: String,
      default: 'default',
      validator(val) {
        return ['default', 'outlined', 'filled', 'dot'].includes(val)
      },
    },
    icon: [Object, String, Array],
    iconPlacement: {
      type: String,
      default: 'right',
      enum: ['right', 'left'],
    },
    value: {
      type: [String, Number],
      default() {
        if (this.theme === 'new') return this.$t('new')
      },
    },
  },
  computed: {
    iconComp() {
      if (!this.icon) return
      return IconBinding(this.icon)
    },
  },
}
</script>

<style lang="scss">
.badge {
  display: inline-flex;
  align-items: center;
  border-radius: 1rem;
  font-size: 0.8em;
  padding: 2px 7px;

  $states: (
    default: 'grey',
    primary: 'primary',
    secondary: 'secondary',
    info: 'info',
    warning: 'warning',
    success: 'dark-green',
    error: 'error',
    new: 'error',
  );

  &--align-left {
    flex-direction: row-reverse;

    .badge__icon {
      margin-left: 0;
      margin-right: 0.5em;
    }
  }

  &__dot {
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 50%;
    flex-shrink: 0;
    margin-right: 8px;
  }

  &__icon {
    margin-left: 0.5em;
  }

  @each $name, $key in $states {
    &--type-dot {
      &.badge--theme-#{$name} {
        color: hsl(var(--#{$key}-h), var(--#{$key}-s), 20%);
        background-color: hsl(var(--#{$key}-h), var(--#{$key}-s), 95%);
        border: 1px solid hsl(var(--#{$key}-h), var(--#{$key}-s), 85%);

        .badge__dot {
          background-color: hsl(var(--#{$key}-h), var(--#{$key}-s), 50%);
        }
      }
    }

    &--type-default {
      &.badge--theme-#{$name} {
        color: hsl(var(--#{$key}-h), var(--#{$key}-s), 20%);
        background-color: hsl(var(--#{$key}-h), var(--#{$key}-s), 95%);
        border: 1px solid hsl(var(--#{$key}-h), var(--#{$key}-s), 85%);
      }
    }

    &--type-outlined {
      &.badge--theme-#{$name} {
        color: hsl(var(--#{$key}-h), var(--#{$key}-s), 20%);
        border: 1px solid var(--#{$key});
      }
    }

    &--type-filled {
      &.badge--theme-#{$name} {
        color: var(--#{$key}-contrast);
        background-color: var(--#{$key});
        border: 1px solid var(--#{$key});
      }
    }
  }
}
</style>
